import { render, staticRenderFns } from "./teamModal.vue?vue&type=template&id=64b4a094&"
import script from "./teamModal.vue?vue&type=script&lang=ts&"
export * from "./teamModal.vue?vue&type=script&lang=ts&"
import style0 from "./teamModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports